module.exports = __webpack_public_path__ + "20006a2b80400856eeccb9fa4ac6f89f.png";